module.exports = __webpack_public_path__ + "static/img/wavm8s-001-klahrk.3c81f7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-001-klahrk.jpg
// module id = 6Enn
// module chunks = 0